var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ji847iqwma",
    d: "M.9 0h9.395c.25 0 .49.104.66.288l5.905 6.367c.154.166.24.385.24.612V24.3c0 .497-.403.9-.9.9H.9c-.497 0-.9-.403-.9-.9V.9C0 .403.403 0 .9 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1236 -912) translate(745 794) translate(25 62) translate(0 49) translate(463 3) translate(3 4) translate(4.95 .9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7zn7t8ai0b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ji847iqwma"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#1E2447",
    strokeOpacity: 0.15,
    strokeWidth: 0.9,
    d: "M10.295-.45c.375 0 .734.157.99.432h0l5.905 6.367c.231.25.36.577.36.918h0V24.3c0 .373-.151.71-.395.955-.245.244-.582.395-.955.395h0H.9c-.373 0-.71-.151-.955-.395-.244-.245-.395-.582-.395-.955h0V.9c0-.373.151-.71.395-.955C.19-.299.527-.45.9-.45h9.395z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#1E2447",
    strokeOpacity: 0.15,
    strokeWidth: 0.9,
    d: "M11.25.45h8.1v6.3H13.5c-.621 0-1.184-.252-1.591-.659-.407-.407-.659-.97-.659-1.591h0V.45z",
    mask: "url(#7zn7t8ai0b)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#37B24D",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 5.4,
    fontWeight: "bold",
    mask: "url(#7zn7t8ai0b)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3.328,
    y: 22.1
  }, "PDF"))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.d6a59cde.svg";
export { ForwardRef as ReactComponent };